import { classnames } from '@aibees/shared/utils';
import { memo } from 'react';
import { CompanySimilaritySearch } from '../company-similarity-search';
import * as Styled from './styles';
import * as SX from './sx';
import type { HomeCompanySearchProps as Props } from './types';

export const HomeCompanySearch = memo(({ className }: Props) => {
  return (
    <Styled.Wrapper
      className={classnames('HomeCompanySearch', className)}
      sx={SX.root}
    >
      <CompanySimilaritySearch renderMode="dialog" />
    </Styled.Wrapper>
  );
});

HomeCompanySearch.displayName = 'HomeCompanySearch';
